module.exports = __webpack_public_path__ + "static/media/icon_schedule_schedule_spacegray.e7cd6c0c.svg";